import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createBlock as _createBlock } from "vue"

const _hoisted_1 = { style: {"display":"flex","margin-bottom":"0.2rem","justify-content":"space-between"} }
const _hoisted_2 = { style: {"display":"flex"} }
const _hoisted_3 = ["src"]
const _hoisted_4 = { style: {"height":"0.5rem","display":"flex","flex-direction":"column","justify-content":"space-between","width":"1.52rem"} }
const _hoisted_5 = { style: {"font-size":"0.16rem","color":"#333333"} }
const _hoisted_6 = { style: {"margin-left":"0.25rem","height":"0.5rem","display":"flex","flex-direction":"column","justify-content":"space-between"} }
const _hoisted_7 = { style: {"font-size":"0.12rem"} }
const _hoisted_8 = { style: {"color":"#000000"} }
const _hoisted_9 = { style: {"color":"#000000"} }
const _hoisted_10 = {
  key: 0,
  style: {"font-size":"0.12rem"}
}
const _hoisted_11 = {
  key: 1,
  style: {"font-size":"0.12rem"}
}
const _hoisted_12 = { key: 1 }

import { ref, nextTick } from "vue";
import { useRouter } from "vue-router";

export default /*@__PURE__*/_defineComponent({
  __name: 'numberOfApplicantsSelect',
  props: {
  item: { type: Object, default: {} },
  type: { type: Number, default: 0 },
},
  setup(__props, { expose: __expose }) {

const router = useRouter();
const radio = ref("");
const yyy = __props;

const Details = (item) => {
  router.push({
    path: "/ShadowComposerHomepage",
    query: { id: item.userId },
  });
};

const init = (e) => {
  // console.log(222222222);
  radio.value = "";
};
__expose({ init, radio });

return (_ctx: any,_cache: any) => {
  const _component_el_radio = _resolveComponent("el-radio")!
  const _component_el_radio_group = _resolveComponent("el-radio-group")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("img", {
          style: {"width":"0.5rem","height":"0.5rem","background":"#ccc","border-radius":"50%","margin-right":"0.12rem"},
          src: __props.item.avatar ? __props.item.avatar : require('@/assets/logo.png')
        }, null, 8, _hoisted_3),
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("div", _hoisted_5, _toDisplayString(__props.item.userName), 1),
          _cache[2] || (_cache[2] = _createElementVNode("div", { style: {"color":"#015243","background":"#e1fefc","padding":"0.02rem 0.12rem","box-sizing":"border-box","font-size":"0.12rem"} }, " 标识山西认证导演 ", -1))
        ])
      ]),
      _createElementVNode("div", _hoisted_6, [
        _createElementVNode("div", _hoisted_7, [
          _cache[3] || (_cache[3] = _createElementVNode("span", null, "创作", -1)),
          _cache[4] || (_cache[4] = _createElementVNode("span", { style: {"color":"#000000"} }, " 0 ", -1)),
          _cache[5] || (_cache[5] = _createElementVNode("span", null, " | ", -1)),
          _cache[6] || (_cache[6] = _createElementVNode("span", null, "粉丝", -1)),
          _createElementVNode("span", _hoisted_8, " " + _toDisplayString(__props.item.fansNumber) + " ", 1),
          _cache[7] || (_cache[7] = _createElementVNode("span", null, " | ", -1)),
          _cache[8] || (_cache[8] = _createElementVNode("span", null, "签单", -1)),
          _createElementVNode("span", _hoisted_9, " " + _toDisplayString(__props.item.signingNumer) + " ", 1)
        ]),
        (__props.item.remark)
          ? (_openBlock(), _createElementBlock("div", _hoisted_10, _toDisplayString(__props.item.remark), 1))
          : (_openBlock(), _createElementBlock("div", _hoisted_11, "暂无简介"))
      ]),
      _createElementVNode("div", null, [
        (__props.type == 0)
          ? (_openBlock(), _createBlock(_component_el_radio_group, {
              key: 0,
              modelValue: radio.value,
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((radio).value = $event)),
              class: "ml-4"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_radio, {
                  label: "1",
                  size: "small"
                })
              ]),
              _: 1
            }, 8, ["modelValue"]))
          : (_openBlock(), _createElementBlock("div", _hoisted_12, [
              _createElementVNode("div", {
                class: "topBtn",
                onClick: _cache[1] || (_cache[1] = ($event: any) => (Details(__props.item)))
              }, "进入主页")
            ]))
      ])
    ])
  ]))
}
}

})